import { Stack, Text, TextProps } from '@instabox/consumer-web-ui'
import { FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import ContactUsLinkIcon from './ContactUsLinkIcon'
import { ContactUsType } from './types'

interface ContactUsLinkProps extends ContactUsType, TextProps {
  value: string
  withIcon?: boolean
}

const getUrlWithPrefix = (type: string, value): string => {
  switch (type) {
    case 'email':
      return `mailto:${value}`
    case 'phone':
      return `tel:${value}`
    case 'sms':
      return `sms:${value}`
    default:
      return null
  }
}

const getLabelKey = (type: string): string => {
  switch (type) {
    case 'email':
      return 'help.email_us'
    case 'phone':
      return 'help.call_us'
    case 'sms':
      return 'help.message_us'
    default:
      return null
  }
}

const ContactUsLink: FC<ContactUsLinkProps> = ({ type, value, withIcon = false, ...textProps }) => {
  const { formatMessage } = useIntl()
  return (
    <Stack layout="horizontal" gap="sm">
      {withIcon && <ContactUsLinkIcon type={type} />}
      <Text {...textProps}>
        <FormattedMessage
          id={getLabelKey(type)}
          values={{
            link: (
              <a
                href={getUrlWithPrefix(type, value)}
                aria-label={formatMessage({ id: getLabelKey(type) }, { link: value })}>
                {value}
              </a>
            ),
          }}
        />
      </Text>
    </Stack>
  )
}

export default ContactUsLink
